// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import axios from 'axios'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import dayjs from 'dayjs'
// import BScroll from 'better-scroll'
import router from './router'
import htmlToPdf from '@/api/htmlToPdf'

import BSvg from '@/components/common/BSvg'
Vue.component('b-svg', BSvg)

Vue.use(htmlToPdf)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$format_time = function(datatime, formattemplate) {
  if (!datatime) {
    return ''
  }
  var reg = /^[0-9]+.?[0-9]*$/
  var time = 0
  if (!reg.test(datatime)) {
    time = new Date(datatime).getTime()
  } else {
    if (datatime.toString().length === 10) {
      time = datatime * 1000
    } else if (datatime.toString().length === 13) {
      time = datatime
    }
  }
  return dayjs(time).format(formattemplate || 'YYYY-MM-DD HH:mm:ss')
}
Vue.prototype.$difftime = function difftime(second_time) {
  var time = parseInt(second_time) + '秒'
  if (parseInt(second_time) > 60) {
    var second = parseInt(second_time) % 60
    var min = parseInt(second_time / 60)
    time = min + '分' + second + '秒'
    if (min > 60) {
      min = parseInt(second_time / 60) % 60
      var hour = parseInt(parseInt(second_time / 60) / 60)
      time = hour + '小时' + min + '分'

      if (hour > 24) {
        hour = parseInt(parseInt(second_time / 60) / 60) % 24
        var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24)
        time = day + '天' + hour + '小时'
      }
    }
  }
  return time
}
// Vue.use(AMap)
dayjs().format()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js